import '../../components/Avatar.js';
import '../../components/CollapsibleSection.js';
import '../../components/DefaultLoadingComponent.js';
import '../../components/GooglePlaceAddress.js';
import React__default, { useState, useRef, useEffect } from 'react';
import '../../components/Image.js';
import '../../components/PromotionAlert.js';
import '../../components/StandardHeader.js';
import '../../components/Chat.js';
import '../../components/CreditApp.js';
import '../../components/EkhoDealerFooter.js';
import '../../components/FinancingModal.js';
import '../../components/FinancingMonthlyEstimateModal.js';
import '../../components/Logo.js';
import '../../components/OrLineDivider.js';
import '../../components/PreviewUpload.js';
import '../../components/PriceSuffix.js';
import 'formik';
import 'libphonenumber-js';
import 'yup';
import '../../constants.js';
import '../../server/serverCalls.js';
import '../../types/CustomerIO.js';
import '../../utils/createLog.js';
import '../../types/SupportHours.js';
import 'bad-words';
import 'moment';
import 'ua-parser-js';
import '../../types/ActionItem.js';
import '../../types/Address.js';
import '../../types/admin_portal/conversations/api/ConversationStatsResponse.js';
import '../../types/admin_portal/conversations/api/GetConversationMessagesResponse.js';
import '../../types/admin_portal/discounts/DiscountCombination.js';
import '../../types/admin_portal/discounts/DiscountMethod.js';
import '../../types/admin_portal/discounts/DiscountStatus.js';
import '../../types/admin_portal/discounts/DiscountType.js';
import '../../types/admin_portal/leads/table/LeadsServiceSort.js';
import '../../types/admin_portal/leads/table/LeadsTableTab.js';
import '../../types/admin_portal/orders/views/OrderDocuments.js';
import '../../types/admin_portal/orders/table/OrderPaymentChoice.js';
import '../../types/admin_portal/orders/table/OrdersServiceSort.js';
import '../../types/admin_portal/orders/table/OrdersTableTab.js';
import '../../types/admin_portal/orders/validation/vinValidation.js';
import '../../types/admin_portal/orders/validation/odometerValidation.js';
import '../../types/admin_portal/orders/validation/engineNumberValidation.js';
import '../../types/admin_portal/orders/validation/inventoryValidation.js';
import '../../types/admin_portal/orders/validation/tempTagValidation.js';
import '../../types/admin_portal/orders/validation/assemblyValidation.js';
import '../../types/admin_portal/orders/validation/inspectionValidation.js';
import '../../types/admin_portal/orders/validation/transitValidation.js';
import '../../types/admin_portal/orders/validation/fileUploadValidation.js';
import '../../types/admin_portal/orders/validation/noteValidation.js';
import '../../types/admin_portal/orders/validation/warrantyValidation.js';
import '../../types/admin_portal/orders/validation/fulfillmentValidation.js';
import '../../types/admin_portal/orders/validation/accessoriesValidation.js';
import '../../types/admin_portal/orders/validation/productionValidation.js';
import '../../types/admin_portal/team/validation/teamSearchDto.js';
import '../../types/admin_portal/team/validation/teamCreateMembersDto.js';
import '../../types/AlgoliaSearchRecord.js';
import '../../types/Auth.js';
import '../../types/auto_debit/Charge.js';
import '../../types/notifications/NotificationEvent.js';
import '../../types/notifications/NotificationSubscription.js';
import '../../types/notifications/NotificationTemplate.js';
import '../../types/BrexTransfer.js';
import '../../types/Buyer.js';
import '../../types/CheckoutCart.js';
import '../../types/CheckoutDisclosures.js';
import '../../types/conversations/Conversation.js';
import '../../types/conversations/ConversationStats.js';
import '../../types/coverage/CoverageBundle.js';
import '../../types/coverage/CoverageProduct.js';
import '../../types/Credits.js';
import '../../types/CtaConfig.js';
import '../../types/dashboards/AdminPortalOrdersDashboard.js';
import '../../types/dashboards/RetailerPortalOrdersDashboard.js';
import '../../types/DiscountCampaign.js';
import '../../types/DiscountTypes.js';
import '../../types/imports/ImportJob.js';
import '../../types/leads/Lead.js';
import '../../types/IncomingCheckoutCart.js';
import '../../types/inventory/Assignment.js';
import '../../types/inventory/CosmeticReport.js';
import '../../types/inventory/InventoryItem.js';
import '../../types/inventory/LockRequest.js';
import '../../types/inventory/MechanicalReport.js';
import '../../types/invitations/Invitation.js';
import '../../types/LegacyIncomingCheckoutCart.js';
import '../../types/lender/events.js';
import '../../types/lender/general.js';
import '../../types/lender/generic.js';
import '../../types/lender/Lender.js';
import '../../types/Listing.js';
import '../../types/Logos.js';
import '../../types/Membership.js';
import '../../types/Oem.js';
import '../../types/OrderExternalStatus.js';
import '../../types/OverflowFees.js';
import '../../types/Payable.js';
import '../../types/PaymentConfig.js';
import '../../types/Payout.js';
import '../../types/PdfFieldTag.js';
import '../../types/PlacedOrder.js';
import '../../types/preorders/Preorder.js';
import '../../types/preorders/PreorderPaymentConfig.js';
import '../../types/PricingModelDetails.js';
import '../../types/PropertyAggregation.js';
import '../../types/pubsub/EventCodes.js';
import '../../types/pubsub/Topics.js';
import '../../types/servicesProviders/services/Services.js';
import '../../types/servicesProviders/services/ServicesProviderAssemblyData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillmentData.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendorData.js';
import '../../types/servicesProviders/services/ServicesProviderDeliveryData.js';
import '../../types/servicesProviders/services/ServicesProviderDomainsData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingData.js';
import '../../types/servicesProviders/services/ServicesProviderFreightData.js';
import '../../types/servicesProviders/services/ServicesProviderInspectionData.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderInventoryData.js';
import '../../types/servicesProviders/services/ServicesProviderLicensureData.js';
import '../../types/servicesProviders/services/ServicesProviderOriginatorData.js';
import '../../types/servicesProviders/services/ServicesProviderPayableData.js';
import '../../types/servicesProviders/services/ServicesProviderPickupData.js';
import '../../types/servicesProviders/services/ServicesProviderPlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwnerData.js';
import '../../types/servicesProviders/services/ServicesProviderRegistrationData.js';
import '../../types/servicesProviders/services/ServicesProviderSaleData.js';
import '../../types/servicesProviders/services/ServicesProviderTariffData.js';
import '../../types/servicesProviders/services/ServicesProviderTempTagData.js';
import '../../types/servicesProviders/services/ServicesProviderTitlingData.js';
import '../../types/servicesProviders/services/ServicesProviderAssembly.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillment.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTax.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendor.js';
import '../../types/servicesProviders/services/ServicesProviderDelivery.js';
import '../../types/servicesProviders/services/ServicesProviderDomains.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTax.js';
import '../../types/servicesProviders/services/ServicesProviderFinancing.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerage.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageSubvention.js';
import '../../types/servicesProviders/services/ServicesProviderFreight.js';
import '../../types/servicesProviders/services/ServicesProviderInspection.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderInventory.js';
import '../../types/servicesProviders/services/ServicesProviderLicensure.js';
import '../../types/servicesProviders/services/ServicesProviderOriginator.js';
import '../../types/servicesProviders/services/ServicesProviderPayable.js';
import '../../types/servicesProviders/services/ServicesProviderPickup.js';
import '../../types/servicesProviders/services/ServicesProviderPlatform.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFees.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwner.js';
import '../../types/servicesProviders/services/ServicesProviderRegistration.js';
import '../../types/servicesProviders/services/ServicesProviderSale.js';
import '../../types/servicesProviders/services/ServicesProviderTariff.js';
import '../../types/servicesProviders/services/ServicesProviderTempTag.js';
import '../../types/servicesProviders/services/ServicesProviderTitling.js';
import '../../types/ReEngagementConfig.js';
import '../../types/Repository.js';
import '../../types/Sardine.js';
import '../../types/Scraping.js';
import '../../types/servicesProviders/configurations/AiBdcSettings.js';
import '../../types/servicesProviders/configurations/AssemblyServiceConfig.js';
import '../../types/servicesProviders/configurations/BdcServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageFulfillmentServiceConfig.js';
import '../../types/servicesProviders/configurations/CoveragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageTaxServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageVendorServiceConfig.js';
import '../../types/servicesProviders/configurations/DeliveryServiceConfig.js';
import '../../types/servicesProviders/configurations/DomainsServiceConfig.js';
import '../../types/servicesProviders/configurations/SharedServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokeragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokerageServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingServiceConfig.js';
import '../../types/servicesProviders/configurations/FreightServiceConfig.js';
import '../../types/servicesProviders/configurations/InspectionServiceConfig.js';
import '../../types/servicesProviders/configurations/InventoryServiceConfig.js';
import '../../types/servicesProviders/configurations/LicensureServiceConfig.js';
import '../../types/servicesProviders/configurations/PickupServiceConfig.js';
import '../../types/servicesProviders/configurations/PlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/ProgramOwnerServiceConfig.js';
import '../../types/servicesProviders/configurations/SaleServiceConfig.js';
import '../../types/servicesProviders/configurations/TempTagServiceConfig.js';
import '../../types/servicesProviders/constants/OnboardingCode.js';
import '../../types/servicesProviders/constants/ProductConfigurationOptions.js';
import '../../types/servicesProviders/serviceAccess/OnboardingCodeToServiceAccess.js';
import '../../types/servicesProviders/serviceAccess/serviceAccess.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessServicesTemplates.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessTemplateCode.js';
import '../../types/servicesProviders/serviceAccess/ServiceSections.js';
import '../../types/servicesProviders/ServicesProvider.js';
import '../../types/servicesProviders/ServicesProviderConfig.js';
import '../../types/servicesProviders/ServicesProviderData.js';
import '../../types/servicesProviders/ServicesProviderPricing.js';
import '../../types/SpecEnrichment.js';
import '../../types/StateAbbreviation.js';
import '../../types/systems/ClientConfig.js';
import '../../types/systems/pcrs/Pcrs.js';
import '../../types/systems/SystemType.js';
import '../../types/UnitedPostalService.js';
import '../../types/Units.js';
import '../../types/User.js';
import '../../types/validation/Validation.js';
import '../../types/Validator.js';
import '../../types/VehicleSpecMetadata.js';
import '../../types/VehicleTypes.js';
import '../../components/bootstrap/Button.js';
import '../../components/bootstrap/forms/FormGroup.js';
import '../../components/bootstrap/forms/Input.js';
import '../../components/bootstrap/forms/Select.js';
import '../../components/bootstrap/forms/Textarea.js';
import '../../components/bootstrap/Modal.js';
import '../../components/bootstrap/Spinner.js';
import '../../components/icon/Icon.js';
import '../../components/TagWrapper.js';
import '../../components/TransferAction.js';
import '../../components/UserContact.js';
import '../../components/VerticalStepper.js';
import '../../components/Wizard.js';
import '../../components/PreQualFailureModal.js';
import '../../components/PreQualInfoCollectModal.js';
import '../../components/PreQualModal.js';
import '../../components/PreQualSuccessModal.js';
import '../../components/bootstrap/Accordion.js';
import '../../components/bootstrap/Alert.js';
import '../../components/bootstrap/Badge.js';
import '../../components/bootstrap/Breadcrumb.js';
import '../../components/bootstrap/Card.js';
import '../../components/bootstrap/Carousel.js';
import '../../components/bootstrap/CarouselCaption.js';
import '../../components/bootstrap/CarouselContainer.js';
import '../../components/bootstrap/CarouselControl.js';
import '../../components/bootstrap/CarouselIndicators.js';
import '../../components/bootstrap/CarouselItem.js';
import '../../components/bootstrap/CarouselSlide.js';
import '../../components/bootstrap/Collapse.js';
import '../../components/bootstrap/Dropdown.js';
import '../../components/bootstrap/forms/Checks.js';
import '../../components/bootstrap/forms/FormText.js';
import '../../components/bootstrap/forms/InputGroup.js';
import '../../components/bootstrap/forms/Label.js';
import '../../components/bootstrap/forms/Validation.js';
import '../../components/bootstrap/ListGroup.js';
import '../../components/bootstrap/Nav.js';
import '../../components/bootstrap/OffCanvas.js';
import '../../components/bootstrap/Option.js';
import '../../components/bootstrap/Pagination.js';
import '../../components/bootstrap/Popovers.js';
import '../../components/bootstrap/Progress.js';
import '../../components/bootstrap/RadioAccordion.js';
import '../../components/bootstrap/ScrollspyNav.js';
import '../../components/bootstrap/SectionAccordion.js';
import '../../components/bootstrap/Toasts.js';
import '../../components/bootstrap/Tooltips.js';
import '../../components/bootstrap/utils.js';
import '../../components/extras/calendarHelper.js';
import '../../components/extras/Chart.js';
import '../../components/extras/PlaceholderImage.js';
import '../../components/footers/InfoCollectFooter.js';
import '../../components/footers/StandardFooter.js';
import '../../components/headers/StandardPageHeader.js';
import '../../components/headers/StandardPageSubHeader.js';
import '../../components/extras/PercentComparison.js';
import '../../components/extras/ReactCreditCardsContainer.js';
import '@babel/runtime/helpers/defineProperty';
import 'react-notifications-component';
import '../../components/extras/Timeline.js';
import '../../components/extras/Todo.js';
import '../../layout/Navigation/Navigation.js';
import '../../layout/Page/Page.js';
import '../../layout/PageWrapper/PageWrapper.js';
import '../../layout/Portal/Portal.js';
import '../../layout/SubHeader/SubHeader.js';
import '../../contexts/themeContext.js';
import 'framer-motion';
import 'react-use';
import '@reactour/tour';
import '../atoms/authAtoms.js';
import '../atoms/mfaChallengeAtoms.js';
import '../atoms/mfaSmsAtoms.js';
import 'firebase/auth';
import { useAuth } from '../hooks/useAuth.js';
import { useCooldown } from '../hooks/useCooldown.js';
import '@tanstack/react-query';
import 'jotai';
import { useAuthContext } from '../providers/AuthContext.js';
import { useSearchParams } from 'react-router-dom';
import '../../rev/layouts/Alignment/alignment.scss';
import '../../rev/layouts/Box.js';
import '../../rev/layouts/Group.js';
import '../../rev/layouts/Section.js';
import '../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../rev/layouts/Stack.js';
import '../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../rev/atoms/Button.js';
import { Callout } from '../../rev/atoms/Callout.js';
import '../../rev/atoms/Card.scss';
import '../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../rev/atoms/CheckboxGroup.scss';
import '../../rev/atoms/Tag.scss';
import '../../rev/atoms/Chip.scss';
import '../../rev/atoms/DateInput.js';
import '../../rev/atoms/Text.js';
import '../../rev/atoms/Divider.scss';
import '../../rev/atoms/Spinner.scss';
import '../../rev/atoms/Dropzone.scss';
import '../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../rev/molecules/RichDescription.js';
import '../../rev/molecules/TitleGroup.scss';
import '../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../rev/atoms/LabelledList.scss';
import '../../rev/atoms/LabelPrice.scss';
import '../../rev/atoms/Link.scss';
import '../../rev/atoms/ListViewGroup.scss';
import '../../rev/atoms/ListViewRow.scss';
import '../../rev/atoms/Note.scss';
import '../../rev/atoms/OldTextInput.js';
import '../../rev/atoms/RadioGroup.scss';
import '../../rev/atoms/SegmentedControl.scss';
import '../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../rev/molecules/Tooltip/Tooltip.js';
import '../../rev/atoms/Slider.scss';
import '../../rev/atoms/SteppedProgressBar.scss';
import '../../rev/atoms/Switch.js';
import '../../rev/atoms/Tabs.scss';
import '../../rev/atoms/TextArea.js';
import '../../rev/atoms/TextInput.js';
import '../../rev/atoms/TimeInput.js';
import '../../rev/atoms/ToggleButton.js';
import '../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../rev/molecules/Accordion.scss';
import '../../rev/molecules/ActionMenu.scss';
import '../../rev/molecules/BankInfo/BankInfo.scss';
import '../../rev/molecules/Carousel.scss';
import '../../rev/molecules/ContentSlider.js';
import '../../rev/molecules/Drawer.js';
import '../../rev/molecules/Dropdown.scss';
import '../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../rev/molecules/Lightbox.scss';
import { GuardId } from '../../components/loadingAtoms.js';
import '../../rev/molecules/LoadingPage.scss';
import '../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../utils/addressCache.js';
import '../../rev/molecules/OldAddressInput.scss';
import '../../rev/atoms/Button.scss';
import '../../rev/molecules/OrderFooter.scss';
import '../../rev/molecules/Pagination.scss';
import '../../rev/molecules/Popover.js';
import '../../rev/molecules/Popup.scss';
import '../../rev/molecules/SearchInput.scss';
import '../../rev/molecules/Sheet.js';
import '../../rev/molecules/Table/Table.scss';
import '../../rev/molecules/Toast.js';
import '../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../rev/organisms/AddressInput.js';
import '../../rev/sections/CalculatePaymentModal.scss';
import '../../rev/sections/ConfirmAddressModal.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import 'react-hook-form';
import '../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../rev/sections/FormModal/FormModal.scss';
import '../../rev/sections/FormModal/types.js';
import '../../rev/sections/LeadsSection/LeadCard.scss';
import './AuthPageLayout.scss';
import { AuthErrorState } from './common/AuthErrorState.js';
import './common/PinInput.scss';
import './ForgotPasswordForm.scss';
import './MfaChallengeForm.scss';
import 'libphonenumber-js/mobile/examples';
import './ResetPassword.scss';
import { useGuardLoadingState } from '../../hooks/useGuardLoadingState.js';

// Cooldown duration in seconds for resend button
const RESEND_COOLDOWN_SECONDS = 30;
const EMAIL_VERIFICATION_ENDPOINT = '/auth_emails/email-verification';
/**
 * Form that handles email verification for both admin and buyer portals.
 */
function VerifyEmailForm({ onCompleteVerification, isCompletingVerification, renderHeader, title: titleOverride, details: detailsOverride, autoSendEmail = true, emailOverride, continueUrl, onVerificationSuccess, onInvalidOobCode, onBackToLogin, }) {
    const { user } = useAuth();
    const { auth, authService, apiClient } = useAuthContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const [verifyState, setVerifyState] = useState(() => {
        // Start verified immediately if Firebase already shows emailVerified — avoids
        // the loading overlay getting stuck when the user returns to this page after
        // clicking the link (auto-send effect skips state transition for verified users).
        if (user?.emailVerified)
            return 'verified';
        if (!user && emailOverride && !autoSendEmail)
            return 'waiting';
        return 'loading';
    });
    const [error, setError] = useState(null);
    const [, setIsInvalidOobCode] = useState(false);
    // Track if initial email was already sent (prevent double-send on re-render)
    const initialEmailSent = useRef(false);
    const verificationAttempted = useRef(false);
    // Cooldown for resend button
    const { cooldownSeconds, startCooldown, isOnCooldown } = useCooldown(RESEND_COOLDOWN_SECONDS);
    // Start cooldown on mount so Resend is rate-limited immediately (not only after first send)
    useEffect(() => {
        startCooldown();
    }, [startCooldown]);
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');
    const inviteToken = searchParams.get('invite');
    const inviteEmail = searchParams.get('email');
    const emailForResend = user?.email ?? emailOverride ?? undefined;
    useGuardLoadingState(GuardId.AUTH, isCompletingVerification || verifyState === 'loading' || verifyState === 'verifying');
    // Handle oobCode verification when user clicks email link
    useEffect(() => {
        const verifyOobCode = async () => {
            // Only verify if we have an oobCode and mode is verifyEmail
            if (!oobCode || mode !== 'verifyEmail' || verificationAttempted.current)
                return;
            verificationAttempted.current = true;
            setVerifyState('verifying');
            setError(null);
            try {
                await authService.applyEmailVerificationCode(oobCode);
                // Reload the user to update emailVerified status
                await auth.currentUser?.reload();
                setVerifyState('verified');
                onVerificationSuccess?.();
            }
            catch (err) {
                const authError = err;
                setError(authError.message);
                setVerifyState('error');
                setIsInvalidOobCode(true);
                onInvalidOobCode?.();
            }
            // Clean up oobCode params from URL (keep invite/email/passwordResetOobCode)
            setSearchParams((prev) => {
                const newParams = new URLSearchParams(prev);
                newParams.delete('mode');
                newParams.delete('oobCode');
                newParams.delete('apiKey');
                newParams.delete('continueUrl');
                newParams.delete('lang');
                return newParams;
            });
        };
        verifyOobCode();
    }, [
        oobCode,
        mode,
        setSearchParams,
        authService,
        auth,
        onVerificationSuccess,
        onInvalidOobCode,
    ]);
    // Auto-send initial email when page loads (if not verifying oobCode)
    // Use emailForResend so we auto-send when email comes from user OR emailOverride (e.g. Buyer flow with email in location state)
    useEffect(() => {
        if (!autoSendEmail || !emailForResend) {
            if (!user && emailOverride)
                setVerifyState('waiting');
            return;
        }
        const sendInitialEmail = async () => {
            // Don't send if:
            // - Already sent
            // - Has oobCode (user came from email link - verifying)
            // - No email to send to
            // - Signed-in user already has email verified
            // - Verification was already attempted (prevents re-send after URL cleanup)
            if (initialEmailSent.current ||
                oobCode ||
                !emailForResend ||
                (user != null && user.emailVerified) ||
                verificationAttempted.current) {
                // Only transition to 'waiting' if we haven't attempted verification
                // (avoids overwriting 'verified' state after successful oobCode verification)
                if (!oobCode &&
                    !(user != null && user.emailVerified) &&
                    emailForResend &&
                    !verificationAttempted.current) {
                    setVerifyState('waiting');
                }
                return;
            }
            initialEmailSent.current = true;
            setVerifyState('sending');
            try {
                await authService.sendEmailVerificationEmail(emailForResend, apiClient, EMAIL_VERIFICATION_ENDPOINT, {
                    continueUrl,
                    inviteToken: inviteToken || undefined,
                    inviteEmail: inviteEmail || undefined,
                });
                setVerifyState('waiting');
            }
            catch (err) {
                const authError = err;
                setError(authError.message);
                // Show the actual error inline rather than the "verification link invalid"
                // screen — that message only applies to oobCode failures, not send failures.
                setVerifyState('waiting');
            }
        };
        sendInitialEmail();
    }, [
        emailForResend,
        user?.emailVerified,
        oobCode,
        inviteToken,
        inviteEmail,
        authService,
        apiClient,
        autoSendEmail,
        emailOverride,
        continueUrl,
        user,
    ]);
    const handleResendEmail = async () => {
        if (!emailForResend || isOnCooldown)
            return;
        setError(null);
        setVerifyState('sending');
        try {
            await authService.sendEmailVerificationEmail(emailForResend, apiClient, EMAIL_VERIFICATION_ENDPOINT, {
                continueUrl,
                inviteToken: inviteToken || undefined,
                inviteEmail: inviteEmail || undefined,
            });
            setVerifyState('waiting');
            startCooldown();
        }
        catch (err) {
            const authError = err;
            setError(authError.message);
            setVerifyState('waiting');
        }
    };
    const handleContinue = async () => {
        try {
            await onCompleteVerification();
        }
        catch (err) {
            console.error('Failed to complete email verification:', err);
            setError('Failed to continue. Please try again.');
        }
    };
    // Verified state: show success + Continue button
    // Check emailVerified before error state — if the email is already verified in Firebase,
    // show success even if applyActionCode threw (e.g. oobCode already used on a prior visit).
    if (user?.emailVerified || verifyState === 'verified') {
        return (React__default.createElement(Stack, { itemsSpacing: '24' },
            renderHeader({
                title: titleOverride ?? 'Email verified!',
                details: detailsOverride ??
                    "You're all set! Let's add an extra layer of security by setting up two-factor authentication.",
            }),
            error && verifyState !== 'error' && React__default.createElement(Callout, { variant: 'error', message: error }),
            React__default.createElement(Button, { variant: 'filled', size: 'large', isFullWidth: true, isDisabled: isCompletingVerification, isLoading: isCompletingVerification, onPress: handleContinue }, "Continue")));
    }
    // Error state - show full error page for invalid oobCode
    if (verifyState === 'error') {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(AuthErrorState, { title: 'Verification failed', message: 'This verification link is invalid or has already been used. Please request a new one from the login page.', primaryButtonText: 'Go to login', onPrimaryAction: onBackToLogin, onBackToLogin: onBackToLogin, disableSecondaryButton: true })));
    }
    // Loading state (initial page load)
    if (verifyState === 'loading') {
        return (React__default.createElement(Stack, { itemsSpacing: '24' }, renderHeader({
            title: titleOverride ?? 'Loading...',
            details: Array.isArray(detailsOverride)
                ? detailsOverride[0]
                : (detailsOverride ?? 'Please wait while we process your request.'),
        })));
    }
    // Verifying state (applying oobCode from email link)
    if (verifyState === 'verifying') {
        return (React__default.createElement(Stack, { itemsSpacing: '24' }, renderHeader({
            title: titleOverride ?? 'Verifying your email...',
            details: Array.isArray(detailsOverride)
                ? detailsOverride[0]
                : (detailsOverride ?? 'Please wait while we confirm your email address.'),
        })));
    }
    // Waiting for user to check email (main state)
    const waitingTitle = titleOverride ?? 'Check your email';
    const waitingDetails = detailsOverride ?? [
        `We've sent a verification link to ${(user?.email || emailOverride) ?? ''}. Click the link to confirm your address and continue.`,
        "You can close this page once you've verified your email.",
    ];
    return (React__default.createElement(Stack, { itemsSpacing: '24' },
        renderHeader({ title: waitingTitle, details: waitingDetails }),
        error && React__default.createElement(Callout, { variant: 'error', message: error }),
        React__default.createElement(Button, { variant: 'secondary', size: 'large', isFullWidth: true, onPress: handleResendEmail, isDisabled: verifyState === 'sending' || isOnCooldown || !emailForResend, isLoading: verifyState === 'sending' }, cooldownSeconds > 0 ? `Resend link • ${cooldownSeconds}s` : 'Resend link')));
}

export { VerifyEmailForm };
//# sourceMappingURL=VerifyEmailForm.js.map
